import css_24w4sg8szyr from './css/AdUI.css';
import Div from './Div.js';
import FullscreenApi from '../Classes/FullscreenApi.js';

const css = css_24w4sg8szyr;

export default class AdUI extends Div
{
	constructor(parentElement,contentPlayer)
	{
		super(parentElement);

		const adPlayer = this.parentElement;

		this.playPause = new PlayPause(this, adPlayer);
		this.volumeBar = new VolumeBar(this, contentPlayer);
		this.progressBar = new ProgressBar(this);
		this.remaining = new Remaining(this);
		this.fullScreen = new FullScreen(this);

		// update the adPlayer volume class for the AdUI mute button icon
		let volumeLevel = null;
		const onVolumeChange = () =>
		{
			const newVolumeLevel = Math.ceil((contentPlayer.muted() ? 0 : contentPlayer.volume()) * 3);
			if(volumeLevel === newVolumeLevel)
			{
				return;
			}
			this.element.classList.remove('volumeLevel'+volumeLevel);
			this.element.classList.add('volumeLevel'+newVolumeLevel);
			volumeLevel = newVolumeLevel;
		};
		contentPlayer.element.addEventListener('volumechange',onVolumeChange);
		onVolumeChange();
	}

	get cssText()
	{
		return css;
	}
}

class PlayPause extends Div
{
	constructor(parentElement, adPlayer)
	{
		super(parentElement);

		this.element.tabIndex = 1;
		this.element.addEventListener
		(
			'click',() =>
			{
				adPlayer.playing(!adPlayer.playing());
			}
		)
	}
}

class VolumeBar extends Div
{
	constructor(parentElement, contentPlayer)
	{
		super(parentElement);
		this.element.tabIndex = 1;

		this.mute = new Mute(this, contentPlayer);
		this.volume = new Volume(this, contentPlayer);
	}
}

class Mute extends Div
{
	constructor(parentElement, contentPlayer)
	{
		super(parentElement);

		this.element.addEventListener('unmute',event => event.stopPropagation());

		this.element.addEventListener
		(
			'click',
			() =>
			{
				contentPlayer.muted(!contentPlayer.muted());
			}
		);
	}
}

class Volume extends Div
{
	constructor(parentElement, contentPlayer)
	{
		super(parentElement);
		this.volumeValue = new VolumeValue(this, contentPlayer);

		this.element.addEventListener
		(
			'mousedown', e =>
			{
				const screenX = e.screenX;
				const offsetX = e.offsetX;

				const setVolume = e =>
				{
					const newScreenX = e.screenX;
					const offset = newScreenX - screenX;
					const newOffsetX = offsetX + offset;

					const volume = Math.min(Math.max(0, newOffsetX) / this.element.clientWidth , 1);
					contentPlayer.volume(volume);
					contentPlayer.muted(false);
				};

				const onMouseMove = e =>
				{
					// ignore fake events generated by the ima sdk
					if(!e.isTrusted)
					{
						return;
					}
					// if the mouse button is released, stop 'capture' ing
					if((e.buttons & 1) === 0)
					{
						this.element.ownerDocument.removeEventListener('mousemove',onMouseMove,true);
						return;
					}
					// don't allow anything else to get mouse events while we are capturing.
					// Tell the browser to stop doing fancy drag and drop and selections and other nonsense that interferes.
					e.stopPropagation();
					e.preventDefault();

					// set volume on every initial click
					setVolume(e);
				};

				// set volume on initial click
				setVolume(e);

				this.element.ownerDocument.addEventListener('mousemove',onMouseMove,true);
			}
		);
	}
}

class VolumeValue extends Div
{
	constructor(parentElement, contentPlayer)
	{
		super(parentElement);
		contentPlayer.element.addEventListener
		(
			'volumechange', () =>
			{
				this.value = contentPlayer.volume()*100;
			}
		)
	}

	set value(value)
	{
		value = parseFloat(value);
		value = value >= 0 ? value <= 100 ? value : 100 : 0;
		this.element.style.width = value.toFixed(2)+'%';
	}
}

class ProgressBar extends Div
{
	constructor(parentElement)
	{
		super(parentElement);
		this.progressValue = new ProgressBarValue(this);
	}
}

class ProgressBarValue extends Div
{
	set value(value)
	{
		this.element.style.transition = value ? '' : 'none';
		value = parseFloat(value);
		value = value >= 0 ? value <= 100 ? value : 100 : 0;
		this.element.style.width = value.toFixed(2)+'%';
	}
}

class Remaining extends Div
{
	set value(value)
	{
		value = parseFloat(value) | 0;
		const minutes = value/60 | 0;
		const seconds = value - minutes * 60;
		const remaining = '-'+minutes+':'+('0'+seconds).slice(-2);
		this.element.setAttribute('remaining', remaining);
	}
}

class FullScreen extends Div
{
	constructor(parentElement)
	{
		super(parentElement);
		this.element.tabIndex = 1;

		const fullscreenApi = new FullscreenApi(this.element.ownerDocument.querySelector('.mediaGroupContainer'));

		this.element.addEventListener
		(
			'unmute', event =>
			{
				if(fullscreenApi.isFullscreen)
				{
					event.stopPropagation();
				}
			}
		);

		this.element.addEventListener
		(
			'click',() =>
			{
				if(fullscreenApi.isFullscreen)
				{
					fullscreenApi.exitFullscreen();
				}
				else
				{
					fullscreenApi.requestFullscreen()
				}
			}
		);
	}
}